<template>
  <div class="section py-0 px-5">
    <div class="tile app-title">
      <p class="subtitle is-6">Inclure les réseaux confrères</p>
    </div>
    <div class="field">
      <b-switch v-model="avecConfreres" type="is-primary"/>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import * as typesReseauxLc from '@/store/creationOpportunite/venteReseauxLc-mutation-type';
import gestionErreur from '@/services/general/gestionErreur';

const VenteReseauxLc = createNamespacedHelpers('venteReseauxLc');

export default {
  name: 'confreres',
  data() {
    return {
    };
  },
  computed: {
    ...VenteReseauxLc.mapGetters({
      avecConfreresLc: 'avecConfreresLc',
    }),
    avecConfreres: {
      get() {
        return this.avecConfreresLc;
      },
      set(value) {
        this.setAvecConfreres(value);
        this.rechercheVentesReseaux();
      },
    },
  },
  methods: {
    ...VenteReseauxLc.mapMutations({
      setAvecConfreres: typesReseauxLc.SET_AVEC_CONFRERES,
    }),
    ...VenteReseauxLc.mapActions({
      actionsRechercheReseauxLc: 'rechercheReseauxLc',
    }),
    rechercheVentesReseaux() {
      const loadingComponent = this.$buefy.loading.open({ container: null });
      this.actionsRechercheReseauxLc().then(() => {
        loadingComponent.close();
      }).catch((e) => {
        loadingComponent.close();
        gestionErreur('Erreur lors de la recherche des réseaux LC liée au filtre confrere', e);
      });
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/creationOpportunite/venteReseauxLc/filtres/confreres.vue